import angular from 'angular';

type NodeFactory = any;

export class NodeService {
  static $inject = ['NodeFactory'];

  tree = {
    node: new this.NodeFactory({}),
    model: { selected: false, partial: false },
  };

  constructor(private NodeFactory: NodeFactory) {}

  getTree() {
    return this.tree;
  }

  toggleNode(treeNodeCtrl, nodeModel) {
    const selected = nodeModel.selected;

    treeNodeCtrl.node.traverseChildren((node) => {
      if (node) {
        const indeterminate = this.isNodeCtrlPartiallySelected(node.value);
        node.value.model.selected = selected;
        node.value.model.partial = indeterminate;
      }
    });

    nodeModel.partial = this.isNodeCtrlPartiallySelected(treeNodeCtrl);
    this.updateTree();
  }

  toggleTree() {
    this.tree.node.traverseChildren((node) => {
      node.value.model.selected = this.tree.model.selected;
    });

    this.updateTree();
  }

  updateTree() {
    this.tree.node.traverseChildren((node) => {
      node.value.model.partial = this.isNodeCtrlPartiallySelected(node.value);
      node.value.model.selected = this.isNodeCtrlSelected(node.value);
    });

    const selected = this.isNodeCtrlSelected(this.tree.node.value);
    const partial = this.isNodeCtrlPartiallySelected(this.tree.node.value);

    this.tree.model.partial = partial;
    this.tree.model.selected = selected;
  }

  isNodeCtrlPartiallySelected(treeNodeCtrl) {
    const metadata = this.getNodeMetadataFromTreeNodeCtrl(treeNodeCtrl);
    return metadata.selected > 0 && metadata.selected < metadata.total;
  }

  isNodeCtrlSelected(treeNodeCtrl) {
    if (treeNodeCtrl.node.isLeaf()) {
      return treeNodeCtrl.model ? !!treeNodeCtrl.model.selected : false;
    }

    const metadata = this.getNodeMetadataFromTreeNodeCtrl(treeNodeCtrl);

    return metadata.selected > 0;
  }

  getNodeMetadataFromTreeNodeCtrl(nodeCtrl) {
    var totalNodes = 0;
    var countSelected = 0;

    nodeCtrl.node.traverseChildren(function (node) {
      totalNodes += 1;

      if (node.value.model.selected) {
        countSelected += 1;
      }
    });

    return {
      total: totalNodes,
      selected: countSelected,
    };
  }
}

export const NodeServiceModule = angular
  .module('acme.common.service.node', ['acme.common.factory.node'])
  .service('NodeService', NodeService).name;
